/**
 * Neutral, NON-protected placeholder shown while the session status is being
 * determined (unknown/restoring). It reveals no protected content and no
 * identity — it is what "we do not yet know if you are signed in" looks like.
 */
export function SessionLoading({ label }: { label: string }) {
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#475569',
        font: '500 1rem system-ui, sans-serif',
      }}
    >
      {label}
    </div>
  )
}
